module.exports = __webpack_public_path__ + "img/activity_bg.4c941c2c.png";